import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
// baseUrl
import { baseURL } from "utils/api";
import axios from "utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Index() {
  const [subjectName, setSubjectName] = useState("");
  const [selectedBoard, setSelectedBoard] = useState("");
  const [boards, setBoards] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch boards on component mount
  useEffect(() => {
    fetchBoards();
  }, []);

  const fetchBoards = async () => {
    try {
      const response = await axios.get(`${baseURL}/boards`);
      console.log("Board API Response:", response.data);
      if (response.data.success) {
        // Filter out deleted boards
        const activeBoards = response.data.data.filter((board) => !board.isDeleted);
        console.log("Active Boards:", activeBoards);
        setBoards(activeBoards);
      }
    } catch (error) {
      console.error("Error fetching boards:", error);
      toast.error("Failed to load boards");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!subjectName.trim()) {
      toast.error("Subject name cannot be empty");
      return;
    }

    if (!selectedBoard) {
      toast.error("Please select a board");
      return;
    }

    setLoading(true);
    console.log("New Subject Added:", subjectName, "Board:", selectedBoard);

    axios
      .post(`${baseURL}/subjects`, {
        name: subjectName,
        board: selectedBoard,
      })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data?.message || "Subject added successfully");
        navigate("/curriculum");
      })
      .catch((error) => {
        console.error("Error adding subject:", error);
        toast.error(
          error.response?.data?.error || error.response?.data?.message || "Failed to add subject"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card sx={{ p: 3, borderRadius: "16px", boxShadow: 3 }}>
            <ArgonTypography mb={1} variant="h5" fontWeight="bold">
              Add Subject
            </ArgonTypography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <ArgonBox display="flex" flexDirection="column" gap={2}>
                {/* Board Dropdown */}
                <ArgonBox>
                  <FormControl fullWidth>
                    <InputLabel id="board-select-label">Select Board</InputLabel>
                    <Select
                      labelId="board-select-label"
                      id="board-select"
                      value={selectedBoard}
                      label="Select Board"
                      onChange={(e) => setSelectedBoard(e.target.value)}
                      sx={{ height: "45px" }}
                    >
                      <MenuItem value="">
                        <em>Select a board</em>
                      </MenuItem>
                      {boards && boards.length > 0 ? (
                        boards.map((board) => (
                          <MenuItem key={board._id} value={board._id}>
                            {board.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>
                          <em>No boards available</em>
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </ArgonBox>

                {/* Subject Name Input */}
                <ArgonBox>
                  <ArgonInput
                    type="text"
                    placeholder="Enter Subject Name"
                    value={subjectName}
                    onChange={(e) => setSubjectName(e.target.value)}
                    fullWidth
                  />
                </ArgonBox>

                {/* Submit Button */}
                <ArgonBox>
                  <ArgonButton
                    color="primary"
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={loading}
                  >
                    {loading ? "Adding..." : "Add Subject"}
                  </ArgonButton>
                </ArgonBox>
              </ArgonBox>
            </form>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Index;
